/**
 * 处理人员实体
 */

import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Input,
    Row,
    Col,
    message,
    InputNumber,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [weight, setWeight] = useState(1);
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setWeight(1);
        setDescription('');

    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setOpen(true);
            setWeight(props.record.weight);
            setDescription(props.record.description);
        }
    }, [props]);


    const ok = () => {
        //  参数校验
        if (!description) {
            message.error('修改说明不能为空！', CNF.messageDuration);
            return;
        }
        setLoading(true);
        $.ajax
            ({
                url: `${CNF.api}wo/dousers/${props.record.key}`,
                headers: AddRequestHeaders(),
                type: 'PUT',
                dataType: 'JSON',
                data: JSON.stringify({
                    'weight': weight,
                    'description': description,
                }),
            }).done(function (data) {
                if (data.res === 0) {
                    messageApi.success(data.msg, CNF.messageDuration);
                    setTimeout(function () {
                        cancel();
                        props.isRefresh();
                    }, CNF.messageDuration * 1000);
                } else {
                    setLoading(false);
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }).fail(function (data) {
                setLoading(false);
                messageApi.error(data.responseJSON.detail, CNF.messageDuration);
            });
    };

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            {contextHolder}
            <Modal
                width={500}
                title={props.record ? props.record.do_user + '-' + props.record.number : ''}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >

                <Row>
                    <Col span={24}>{rff}绩效权重</Col>
                    <Col span={24}>
                        <InputNumber
                            style={{ width: '100%' }}
                            min={1}
                            max={10}
                            step={0.1}
                            onChange={(value) => setWeight(value)}
                            value={weight}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}修改说明</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='修改说明可写在这里....'
                            autoSize={{ minRows: 3, maxRows: 6 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </ConfigProvider>
    );
}

export default Entity